import { useflexItemSpacerStyles } from './FlexItemSpacer.styles';

export const FlexItemSpacer = ({ flex }: any) => {
  const classes = useflexItemSpacerStyles({ flex });
  return <div className={classes.root} />;
};
